const GreenFlash = ({width = "22"}) =>(

<svg width={width} height="29" viewBox="0 0 22 29" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.1817 12.3925H14.8206V2.23072C14.8206 -0.140354 13.5363 -0.620214 11.9697 1.15809L10.8406 2.44242L1.28577 13.3098C-0.0267912 14.7918 0.523637 16.0055 2.49953 16.0055H6.86061V26.1673C6.86061 28.5383 8.14494 29.0182 9.71154 27.2399L10.8406 25.9556L20.3955 15.0881C21.708 13.6062 21.1576 12.3925 19.1817 12.3925Z" fill="#40E5A0"/>
</svg>

)

export default GreenFlash;